module.exports = __webpack_public_path__ + "img/antes_despues_282.f278c57e.png";